export const appRoutes = {
  LOGIN: "/login",
  DASHBOARD: "/app/dashboard",
  ADD_TRUCKING_MATERIAL: "/app/add-trucking-material",
  VIEW_TRUCKING_MATERIAL: "/app/view-trucking-material",
  ADD_JOB: "/app/trucking-material",
  VIEW_TRUCKING_MATERIAL_ID: "/app/view-trucking-material/:id",
  UPDATE_TRUCKING_MATERIAL: "/app/update-trucking-material/",
  UPDATE_TRUCKING_MATERIAL_ID: "/app/update-trucking-material/:id",
  LIST_DOCUMENTS: "/app/documents",
  EDIT_QUOTE_TEMPLATE: "/app/edit-quote-template/",
  EDIT_QUOTE_TEMPLATE_ID: "/app/edit-quote-template/:id",
  EDIT_ESTIMATE_TEMPLATE: "/app/edit-estimate-template/",
  EDIT_ESTIMATE_TEMPLATE_ID: "/app/edit-estimate-template/:id",
  MANAGE_ROLES_LISTING: "app/manage-roles",
  INTERNAL_ROLES_FORM: "/app/manage-roles-internal",
  INTERNAL_ROLES_FORM_ID: "/app/manage-roles-internal/:id?",
  VIEW_TICKET_UPLOAD_LISTING: "/app/ticket-upload",
  VIEW_TICKET_UPLOAD_REVIEW: "/app/ticket-upload-review/",
  VIEW_TICKET_UPLOAD_REVIEW_ID: "/app/ticket-upload-review/:id",
  VIEW_TICKET_PROCESSING_LISTING: "/app/ticket-processing",
  VIEW_TICKET_PROCESSING_REVIEW: "/app/ticket-processing-review/",
  VIEW_TICKET_PROCESSING_REVIEW_ID: "/app/ticket-processing-review/:id",
  INVOICE_MANAGEMENT: "/app/invoiceManagement", //TODO: Change when changing invoiceManagement to invoice-management,
  LIEN_PROCESS: "/app/lien-tool",
  LIEN_DETAIL_VIEW_PATH: "/app/lien-tool-details",
  LIEN_DETAIL_VIEW: "/app/lien-tool-details/:id",
  CUSTOMER_DATABASE: "/app/customer-database",
  CUSTOMER_PROFILE: "/app/customer-profile",
  CUSTOMER_PROFILE_ID: "/app/customer-profile/:id",
  JOB_DATABASE: "/app/job-database",
  JOB_PROFILE: "/app/job-profile",
  JOB_PROFILE_ID: "/app/job-profile/:id",
  QUARRY_DATABASE: "/app/quarry-database",
  QUARRY_TOOL: "/app/quarry-finder-tool", //Legacy Quarry Database Path
  QUARRY_PROFILE: "/app/quarry-profile",
  QUARRY_PROFILE_ID: "/app/quarry-profile/:id",
  OWNER_OPERATOR_PROFILE: "/app/twisted-nail/carrier-profile",
};
